module.exports = function(posts) {
	'use strict'
	posts.directive('addToDictionaryModal',addToDictionaryModal);
	addToDictionaryModal.$inject=['$timeout','refreshtokenService','alertService','serverError','postDataService','offlineError'];
	function addToDictionaryModal($timeout,refreshtokenService, alertService,serverError,postDataService,offlineError) {
		return {
			restrict: 'E',
			scope: {
				currentPostObj:"="
			},
			template: require('./partial/dictionary.html'),
			link: function(scope, ele, $attrs, ctrl) {
				var state = 'posts';
				var postFunction = function() {   
		          postDataService.save({
		            param1:'posts',
		            param2:'addtodictionary' 
		          },{
		            'word':scope.currentPostObj.misspelledWord
		          }).$promise.then(function(postData){
		            alertService('success','Success ', postData.message, 2000);
		            var index = scope.currentPostObj.spelledArray.indexOf(scope.currentPostObj.misspelledWord)
		            scope.currentPostObj.spelledArray.splice(index,1);
		            if(scope.currentPostObj.spelledArray.length>0) {
		            	scope.currentPostObj.titleSpellInCorect = true;
		            } else {
		            	scope.currentPostObj.titleSpellInCorect = false;
		            }
		            $timeout(function() {
		            	scope.currentPostObj.closeDictionaryModal()
		            })
		          }, function(error){
					if(!window.navigator.onLine) {
						offlineError()
						alertService('danger','Opps! ', 'Please check your internet connection and try again.');
						return
					}
		            if(error.status ==401) {
		              var promise = refreshtokenService.getAccessToken();
		              promise.then(
		                function(answer) {
		                  if(answer==200) {   
		                    postFunction();
		                  }
		                },
		                function(error) {
		                  // report something
		                },
		                function(progress) {
		                 // report progress
		              });
		            }else if(error.status ==502) {
		              serverError();
		            }else {
		              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
		            }
		          });
		        }
		        scope.addToDictionary = function() {
		        	postFunction();
		        }
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/addToDictionaryDirective.js
// module id = 554
// module chunks = 0